<template>
  <div>
    <h3>Branding</h3>
    <p>Select your logo or banner image you would like to display at the top of your form (optional) </p>
    <div class="Question-container">
      <h3>Logo</h3>
      <p>Select or upload a company logo</p>
      <div v-if="questionConfig.media.logo !== null">
        <div class="Question-container">
          <div
            class="Image-wrapper"
            :class="{'Selected' : questionConfig.media.logo.is_displayed}"
          >
            <span
              v-if="questionConfig.media.logo.is_displayed"
              class="Icon-s Icon-check"
            />
            <button
              class="RemoveButton"
              @click="handleRemoveLogo"
            >
              <span
                class="Icon-s Icon-trash"
              />
            </button>
            <img
              id="eventLogo"
              :src="questionConfig.media.logo.name"
              alt="Event Logo Image"
              @click="handleSelectLogo"
            >
          </div>
        </div>
      </div>
      <form>
        <input
          id="eventCompanyLogo"
          type="file"
          name="logoFilename"
          accept="image/*"
          @change="handleFileUpload('logo', $event)"
        >
        <p>The Company Logo must be in JPG, PNG or GIF format at 150px × 150px.</p>
      </form>
      <hr>
      <div :class="[{'Selected' : true }, 'Question-container']">
        <h3>Banner</h3>
        <p>Select or upload a header image</p>
        <div v-if="questionConfig.media.banner !== null">
          <div
            class="Image-wrapper"
            :class="{'Selected' : questionConfig.media.banner.is_displayed}"
          >
            <span
              v-if="questionConfig.media.banner.is_displayed"
              class="Icon-s Icon-check"
            />
            <button
              class="RemoveButton"
              @click="handleRemoveBanner"
            >
              <span
                class="Icon-s Icon-trash"
              />
            </button>
            <img
              id="eventBanner"
              :src="questionConfig.media.banner.name"
              alt="Event Header Image"
              @click="handleSelectBanner"
            >
          </div>
        </div>
      </div>

      <input
        id="eventHeaderImage"
        type="file"
        name="headerFilename"
        @change="handleFileUpload('banner', $event)"
      >
      <p>The Event Banner must be in JPG, PNG or GIF format with width: 700px.</p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    question: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      questionConfig: this.question,
    };
  },
  methods: {
    ...mapMutations('events', ['updateEventContent']),
    handleFileUpload(type, { currentTarget: input }) {
      // Take the uploaded image and convert to a base64 string in order to show a preview in the browser
      // Add this to the event in order for it to be added to the form.
      if (input.files && input.files[0]) {
        const reader = new FileReader();

        reader.onload = (e) => {
          this.questionConfig.media = {
            ...this.questionConfig.media,
            [type]: {
              name: e.target.result,
              is_displayed: false,
            },
          };
          this.updateEventContent({ media: this.questionConfig.media });

          if (type === 'logo') {
            this.handleSelectLogo();
          } else {
            this.handleSelectBanner();
          }
        };

        reader.readAsDataURL(input.files[0]); // convert to base64 string
      }
    },
    handleSelectLogo() {
      this.questionConfig.media.logo.is_displayed = true;

      if (this.questionConfig.media.banner) {
        this.questionConfig.media.banner.is_displayed = false;
      }

      this.updateEventContent({ media: this.questionConfig.media });
    },
    handleSelectBanner() {
      this.questionConfig.media.banner.is_displayed = true;

      if (this.questionConfig.media.logo) {
        this.questionConfig.media.logo.is_displayed = false;
      }

      this.updateEventContent({ media: this.questionConfig.media });
    },
    handleRemoveLogo() {
      this.questionConfig.media.logo = null;
      this.updateEventContent({ media: this.questionConfig.media });
    },
    handleRemoveBanner() {
      this.questionConfig.media.banner = null;
      this.updateEventContent({ media: this.questionConfig.media });
    },
  },
};

</script>
<style scoped lang="less">
    #eventBanner {
      width: 100%;

      &.Selected {
        border: 1px solid #046FF0;
      }
    }
    .Image-wrapper {
      display: inline-block;
      position: relative;

      &.Selected {
        border: 1px solid #046FF0;

        .Icon-check {
          position: absolute;
          right: -11px;
          top: -11px;
          background: #046FF0;
          padding: 2px;
          border-radius: 50%;
          color: white;
          font-size: .9rem;
          height: 24px;
          width: 24px;
          text-align: center;
        }
        .RemoveButton {
            right: -11px;
            top: 15px;
        }
      }

      .RemoveButton {
      position: absolute;
      right: -7px;
      top: -11px;
      cursor: pointer;
      border-radius: 50%;
      color: white;
      background-color: #F10000;
      font-size: .9rem;
      height: 24px;
      width: 24px;
      margin-left: 5px;
    }
    }
</style>
